import { Fragment } from 'react';
import { Modal } from '@JohnLewisPartnership/jl-design-system/components/modal/Modal';

import Loading from '../../loading/Loading';
import { useCompareContext } from '../../../context/PlpContext';

import { ContextProps } from '../../../context/initialisers/useCompareDataInitialiser';

import styles from './CompareModal.module.scss';
import { CompareTable } from './compare-table/CompareTable';
import { CompareHeader } from './compare-header/CompareHeader';
import { EnrichedCompareProduct } from '../../../utils/types/types';

type Props = {
  products: Array<EnrichedCompareProduct> | null;
};

export const CompareModal = ({ products }: Props) => {
  const compare: ContextProps = useCompareContext();

  const comparing: number = compare.products.length;

  return (
    <Modal
      className={styles.header}
      footer={false}
      headerCount={comparing}
      headerType="compare"
      isOpen={compare.isOpen}
      modalChildrenClassName={styles.productsContainer}
      onBackButtonClick={compare.close}
      onClearAllButtonClick={compare.removeAll}
      onClose={compare.close}
      title="Compare"
      variant="full-screen"
    >
      {compare.loading ? (
        <Loading showSpinner />
      ) : (
        <Fragment>
          <div className={styles.modalChildren}>
            <div className={styles.productsContainer}>
              <CompareHeader products={products} maxCompare={compare.max} />
            </div>
            <CompareTable
              className={styles.compareContainer}
              maxCompare={compare.max}
              products={products}
              modalHeaderClassName={styles.productsContainer}
            />
          </div>
        </Fragment>
      )}
    </Modal>
  );
};
